import { truncate } from 'lodash-es';

const nameTruncate = (name: string) => {
  return truncate(name, {
    length: 35,
  });
};

export { nameTruncate };
